import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RequireAdminRoute({ children }) {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    if (loading) return;

    if (!user) {
      setIsAdmin(false);
      return;
    }

    // Use Firebase Auth custom claims — no Firestore read needed
    user.getIdTokenResult()
      .then((result) => setIsAdmin(result.claims.admin === true))
      .catch((error) => {
        console.error('Error checking admin access:', error);
        setIsAdmin(false);
      });
  }, [user, loading]);

  if (!loading && (user === null || isAdmin === false)) {
    return <Navigate to="/" replace />;
  }

  if (loading || isAdmin === null) {
    return <p className="p-4">Loading...</p>;
  }

  return children;
}

export default RequireAdminRoute;
